import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import { droneInquire } from "../../services/DroneServices";
import { toast } from "react-toastify";

const DroneEnquiry = ({ setModel, model }) => {
  const { id } = useParams();

  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    comment: "",
    address: "",
  });

  const handleEnquiryModel = () => {
    setModel(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmitEnquiry = () => {
    if (!formData.name || !formData.phoneNumber || !formData.email) {
      return toast.error("Please fill in all required fields");
    }
    if (formData.phoneNumber.length !== 10) {
      return toast.error("Please enter a valid 10-digit number");
    }

    const data = {
      droneId: id,
      name: formData.name,
      email: formData.email,
      number: formData.phoneNumber,
      comment: formData.comment,
      address: formData.address,
    };

    droneInquire(data).then((res) => {
      if (res?.success) {
        toast.success(res.message || "Enquiry submitted successfully");
        setFormData({
          name: "",
          phoneNumber: "",
          email: "",
          comment: "",
          address: "",
        });
        setTimeout(() => setModel(false), 500);
      } else {
        toast.error(res?.message || "Something went wrong");
      }
    });
  };

  return (
    <Modal show={model} onHide={handleEnquiryModel}>
      <Modal.Header className="border-0 pb-0" closeButton></Modal.Header>
      <Modal.Body className="px-4 pb-4 d-flex flex-column justify-content-between">
        <div>
          <h4 className="fw-bold fs_22 color_darkgray">Send your enquiry</h4>
          <div className="row">
            <div>
              <input
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                type="text"
                placeholder="Name"
                className="form-control"
              />
            </div>
            <div className="mt-2">
              <input
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                type="text"
                placeholder="Contact Number"
                className="form-control"
              />
            </div>
            <div className="mt-2">
              <input
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                type="text"
                placeholder="Email"
                className="form-control"
              />
            </div>
            <div className="mt-2">
              <input
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                type="text"
                placeholder="Address"
                className="form-control"
              />
            </div>
            <div className="my-2">
              <textarea
                name="comment"
                value={formData.comment}
                onChange={handleInputChange}
                placeholder="Comment"
                className="form-control"
                cols="30"
                rows="5"
              ></textarea>
            </div>
          </div>
        </div>
        <div className="text-center">
          <button
            onClick={handleSubmitEnquiry}
            className="tab_btn w-100 border-0 py-2 rounded-2 fs_21 fw-semibold ff_inter text-white"
            type="submit"
          >
            Submit <FaArrowRight />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DroneEnquiry;
